/**
 * Esc Close
 * ======================================
 * - close popup layers when esc pressed
 */
class EscClose {
	constructor() {
    this.sidebars = document.querySelectorAll('.sidebar')
		document.addEventListener('keyup', this.clickHandler, false)
	}

	clickHandler = evt => {
		evt = evt || window.event
		let isEscape = false

		if ('key' in evt) {
			isEscape = evt.key === 'Escape' || evt.key === 'Esc'
		} else {
			isEscape = evt.keyCode === 27
		}

		if (isEscape) {
			const sidebarClasses = ['is-open']
			const classes = ['sidebar-is-open', 'sidebar-overlay-is-disabled']

			if(typeof EscCloseAction !== 'undefined' && EscCloseAction == 'home'){
				location.replace(homeUrl);

				return;
			}

			document.body.classList.remove(...classes)

			this.sidebars.forEach(sidebar => {
				sidebar.classList.remove(...sidebarClasses)
			})

			window.history.pushState({}, '', homeUrl);
		}
	}
}

new EscClose()
